import { render, staticRenderFns } from "./OffshoreDebt.vue?vue&type=template&id=3f88ca10&scoped=true&"
import script from "./OffshoreDebt.vue?vue&type=script&lang=js&"
export * from "./OffshoreDebt.vue?vue&type=script&lang=js&"
import style0 from "./OffshoreDebt.vue?vue&type=style&index=0&id=3f88ca10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88ca10",
  null
  
)

export default component.exports